import { Injectable } from '@angular/core';
import { OAuthStorage } from 'angular-oauth2-oidc';
import { authConfig } from '../../oauth-config/oauth-config';
import { CookieService } from 'ngx-cookie-service';
import { auth0authConfig } from '../../oauth-config/auth0-oauth-config';

@Injectable()
export class CustomAuthStorageService implements OAuthStorage {
  private clientId: string;
  constructor(cookieService: CookieService) {
    this.clientId =
      cookieService.get('auth-provider') === 'auth0'
        ? auth0authConfig.clientId
        : authConfig.clientId;
  }

  getItem(key: string): string {
    return sessionStorage.getItem(`${this.clientId}_${key}`);
  }

  removeItem(key: string): void {
    sessionStorage.removeItem(`${this.clientId}_${key}`);
  }

  setItem(key: string, data: string): void {
    sessionStorage.setItem(`${this.clientId}_${key}`, data);
  }
}
